export class WorkflowStepActivationNotification {
	public viewId: number;
	public folderId: string;

	public static fromJson(other: any): WorkflowStepActivationNotification {
		const instance = new WorkflowStepActivationNotification();
		instance.folderId = other.FolderId;
		instance.viewId = other.ViewId;
		return instance;
	}
}
